/**
 * Integrytas Group - Common Security Module (CSM)
 * Load a job description's default role ids from csm_job_description_role.
 * Used to pre-seed the new-user provision form's role selection.
 */
import { apiDb } from './api_client';

interface JdrRow { job_description_id: number; role_id: number }

/** Active default role ids for a single job description. */
export async function fetchJobDefaultRoles(jobId: number): Promise<number[]> {
  const { data } = await apiDb
    .from('csm_job_description_role')
    .select('job_description_id, role_id')
    .eq('job_description_id', jobId)
    .eq('is_active', 'Y');
  return ((data ?? []) as JdrRow[]).map(r => r.role_id);
}

/** job_description_id -> active default role ids, for eager load with the job list. */
export async function fetchAllJobDefaultRoles(): Promise<Map<number, number[]>> {
  const { data } = await apiDb
    .from('csm_job_description_role')
    .select('job_description_id, role_id')
    .eq('is_active', 'Y');
  const map = new Map<number, number[]>();
  for (const r of (data ?? []) as JdrRow[]) {
    const list = map.get(r.job_description_id) ?? [];
    list.push(r.role_id);
    map.set(r.job_description_id, list);
  }
  return map;
}
